import React, { useRef } from "react";
import { advanceTable, cardSlider } from "../constants";

// swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, A11y } from "swiper/modules";
import "swiper/css";
import CustomBg from "./CustomBg";

const Advanced = () => {
  const swiperRef = useRef(null);

  const goNext = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  };

  const goPrev = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  };

  return (
    <>
      <CustomBg />
      <div className="advance-page">
        <div className="graduate">
          <img className="glass-effect" src="/icons/back-icon.svg" />
          <h5>About to Graduate</h5>
        </div>
        <div className="main-advance-card-slider">
          <Swiper
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            modules={[A11y, Autoplay]}
            spaceBetween={20}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 15,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 10,
              },
              1300: {
                slidesPerView: 6,
                spaceBetween: 10,
              },
            }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            speed={1000}
            loop={true}
          >
            {cardSlider.map((card, index) => (
              <SwiperSlide key={index}>
                <div className="advance-card-slider glass-effect">
                  <img src={card.image} alt="Slide" />
                  <div className="right">
                    <div className="top">
                      <p>{card.topContent1}</p>
                      <p>{card.topContent2}</p>
                    </div>
                    <div className="center">
                      <p>{card.centerContent1}</p>
                      <p>{card.centerContent2}</p>
                    </div>
                    <div className="bottom">
                      <img src={card.timeImage} alt="Time" />
                      <p>{card.bottomContent}</p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Navigation Arrows */}
          <div onClick={goPrev} className="nav-prev">
            <img
              className="glass-effect"
              src="/icons/back-icon.svg"
              alt="Prev"
            />
          </div>
          <div onClick={goNext} className="nav-next">
            <img
              className="glass-effect"
              src="/icons/back-icon.svg"
              alt="Next"
            />
          </div>
        </div>

        <div className="home-toolbar">
          <div className="home-sort">
            <label htmlFor="sort">Sort By:</label>
            <select id="sort">
              <option value="featured">Featured</option>
              <option value="recent">Recent</option>
            </select>
          </div>
        </div>

        <div className="advance-table-wrapper">
          <table className="glass-effect advance-table">
            <thead>
              <tr>
                <th>Coin</th>
                <th>Chart</th>
                <th>Holders</th>
                <th>Own</th>
                <th>Sol</th>
                <th>U.PnL</th>
                <th>R.PnL</th>
                <th>Threads</th>
                <th>Quick Bay</th>
              </tr>
            </thead>

            <tbody>
              {advanceTable.map((coin, index) => (
                <tr key={index}>
                  <td>
                    <div className="coin-td">
                      <img src={coin.image} alt="" className="coin-image" />
                      <div className="coin-td-content">
                        <div className="coin-name">
                          <p>{coin.coinName}</p>
                          <div>
                            <p>{coin.placeholder}</p>
                            <img src="/icons/copy.svg" alt="" />
                          </div>
                        </div>

                        <div className="progress-bar">
                          <div className="glass-effect progress-outer">
                            <div
                              className="progress-inner"
                              style={{ width: `${coin.completePercentage}%` }}
                            />
                          </div>
                          <p>{coin.completePercentage}%</p>
                        </div>

                        <div className="info">
                          <div>
                            <div>
                              <p className="inline">
                                <span className="text-purple">Mc</span>{" "}
                                <span>${coin.mc}k</span>
                              </p>
                            </div>
                            <div className="inline">
                              <img src="/icons/user.svg" alt="" />
                              <p className="placeholder-text">{coin.users}</p>
                            </div>
                          </div>
                          <div>
                            <div className="inline">
                              <span className="text-purple">V</span>
                              <span>${coin.v}k</span>
                            </div>
                            <div className="inline">
                              <div>
                                <p className="inline">
                                  <span className="text-purple">DH</span>
                                  <span className="placeholder-text">
                                    {coin.dhPercentage}%
                                  </span>
                                </p>
                              </div>
                              <div className="inline">
                                <img src="/icons/target.svg" alt="" />
                                <p className="placeholder-text">
                                  {coin.target}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div>
                              <p className="inline">
                                <span className="text-purple">T10</span>
                                <span>{coin.t10Percentage}%</span>
                              </p>
                            </div>
                            <div className="inline placeholder-text">
                              <img src="/icons/clockPurple.svg" alt="" />
                              <p>{coin.createdAt}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="glass-effect graph">
                      <p>
                        Candle Stick <br /> Graph
                      </p>
                    </div>
                  </td>
                  <td>
                    <div className="holders-data holder-name text-purple">
                      {coin.holders.map((holder, index) => (
                        <p key={index}>{holder.name}</p>
                      ))}
                    </div>
                  </td>
                  <td>
                    <div className="holders-data">
                      {coin.holders.map((holder, index) => (
                        <p key={index}>{holder.own}%</p>
                      ))}
                    </div>
                  </td>
                  <td>
                    <div className="holders-data">
                      {coin.holders.map((holder, index) => (
                        <p key={index}>{holder.sol}</p>
                      ))}
                    </div>
                  </td>
                  <td>
                    <div className={`holders-data`}>
                      {coin.holders.map((holder, index) => (
                        <p
                          key={index}
                          className={
                            holder.uPnl >= 0 ? "green-text" : "red-text"
                          }
                        >
                          {holder.uPnl}
                        </p>
                      ))}
                    </div>
                  </td>
                  <td>
                    <div className={`holders-data`}>
                      {coin.holders.map((holder, index) => (
                        <p
                          key={index}
                          className={
                            holder.rPnl >= 0 ? "green-text" : "red-text"
                          }
                        >
                          {holder.rPnl}
                        </p>
                      ))}
                    </div>
                  </td>
                  <td>
                    <div className="thread">
                      <div>
                        <img src={coin.threads.image} alt="" />
                        <p>{coin.threads.name}</p>  
                      </div>
                      <p>{coin.threads.message}</p>
                      <p className="created-at">{coin.threads.createdAt}</p>
                    </div>
                  </td>
                  <td className="quick-bay">
                    <button className="button-purple">
                      <img src="/fish.png" alt="" />
                      {coin.quickBay}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Advanced;
